import React from "react"
import {Image} from "semantic-ui-react"

const SVGIcon = ( {className, src, style = {opacity: 0.667}, ...props} ) => (
    <Image alt={"Icon"} {...props} style={style} className={`${className} svg-icon`} src={src} inline />
)

export default SVGIcon
